<div class="flex flex-col">
  <div class="flex flex-row text-sm color-primary">
    <span>{{item()['id']}}</span>
  </div>
  <div class="flex flex-row">
    <span class="font-bold">{{item()['fzhauptklasse']}}</span>
  </div>
  <div class="flex flex-row">
    <span class="text-light">{{item()['bezeichnung']}}</span>
  </div>
</div>
